<template>
  <div class="password-container">
    <h2 class="title">{{ $t('password.title') }}</h2>
    <p>{{ $t('password.subTitle') }}</p>
    <button class="red-button" @click="requestCode" :disabled="disabledCodeBtn" v-if="hideBtn">{{ $t('password.request') }}</button>

    <input class="cabinet-input cabinet-password " autocomplete="off" :type="code" :placeholder="this.$t('password.code')" v-model="code" v-if="confirmRequest"/>
    <button class="red-button" @click="verifiCode" v-if="confirmRequest">{{ $t('password.submit') }}</button>


    <div class="cabinet-password" v-if="confirmVerification">
      <input class="cabinet-input" autocomplete="new-password" :type="typeCurrentPassword" :placeholder="this.$t('password.current')" v-model="currentPassword" />
      <div
        class="eye-indicator"
        :class="{ 'eye-indicator-closed': !showCurrentPassword }"
        @click="toggleShowCurrentPassword"
      ></div>
    </div>
    <div class="cabinet-password" v-if="confirmVerification">
      <input class="cabinet-input" :type="typeNewPassword" :placeholder="this.$t('password.confirm')" v-model="newPassword" />
      <div
        class="eye-indicator"
        :class="{ 'eye-indicator-closed': !showNewPassword }"
        @click="toggleShowNewPassword"
      ></div>
    </div>

    <div class="cabinet-password" v-if="confirmVerification">
      <input class="cabinet-input" :type="typeRepeatPassword" :placeholder="this.$t('password.repeat')" v-model="repeatPassword" />
      <div
        class="eye-indicator"
        :class="{ 'eye-indicator-closed': !showRepeatPassword }"
        @click="toggleShowRepeatPassword"
      ></div>
    </div>

    <button class="red-button" @click="change" :disabled="disabledBtn" v-if="confirmVerification">{{ $t('password.save') }}</button>

    <Modal v-if="showDialog" @close="showDialog = false" dialogStyle="login-modal">
      <template #header>
        <h3>{{ $t('password.confirm') }}</h3>
      </template>
      <template #body>
        <div>
          <p>{{dialogMessage}}</p>
        </div>
      </template>
      <template #footer>
        <div>
          <button @click="showDialog = false">{{ $t('password.close') }}</button>
        </div>
      </template>
    </Modal>
  </div>
  <Preloader :showModal="showM"></Preloader>
</template>

<script>
import { Auth } from 'aws-amplify';

import Modal from "@/components/Modal";
import Preloader from "@/components/Preloader";

import store from "@/store"

/* import CustomSelector from "@/components/CustomSelector";
import axios from "axios";
 */

import { getCurrentInstance, onMounted, onUnmounted, ref } from "@vue/runtime-core";

export default {
  name: "Password",
  components: {
    Modal, Preloader
  },
  data() {
    return {
      dialogMessage: false,
      showDialog: false,
      currentPassword: null,
      newPassword: null,
      repeatPassword: null,
      typeCurrentPassword: 'password',
      typeNewPassword: 'password',
      typeRepeatPassword: 'password',
      showCurrentPassword: false,
      showNewPassword: false,
      showRepeatPassword: false,
      authUser: null,
      message: null,
      code: null,
      type: null,
      disabledBtn: false,
      disabledCodeBtn: false
      // confirmRequest: false,
      // confirmVerification: false
    };
  },
  created() {
    window.addEventListener('keydown', this.reset);
  },
  methods: {
    toggleShowCurrentPassword() {
      this.showCurrentPassword = !this.showCurrentPassword;
      if (this.showCurrentPassword)
        this.typeCurrentPassword = 'text';
      else
        this.typeCurrentPassword = 'password';
    },
    toggleShowNewPassword() {
      this.showNewPassword = !this.showNewPassword;
      if (this.showNewPassword)
        this.typeNewPassword = 'text';
      else
        this.typeNewPassword = 'password';
    },
    toggleShowRepeatPassword() {
      this.showRepeatPassword = !this.showRepeatPassword;
      if (this.showRepeatPassword)
        this.typeRepeatPassword = 'text';
      else
        this.typeRepeatPassword = 'password';
    },

    // solicitar codigo
    requestCode() {
      //send amplify code
      Auth.verifyCurrentUserAttribute('email')
        .then(() => {
          this.disabledCodeBtn = true
          this.dialogMessage = this.$t('password.dialogMessage');
          this.showDialog = true;
          this.confirmRequest = true;
          this.hideBtn = false
        }).catch((e) => {
          this.dialogMessage = e.message;
          this.showDialog = true;
        });
    },

    // verificar codigo
    verifiCode(){
      // check code and resent with all details
      Auth.verifyCurrentUserAttributeSubmit('email', this.code)
        .then(() => {
          this.confirmVerification = true;
          this.confirmRequest = false;
        }).catch(e => {
          this.dialogMessage = e.message;
          this.showDialog = true;
        });
    },

    // Cambiar contraseña
    change() {
      if (this.currentPassword == null || this.currentPassword.length === 0) {
        this.dialogMessage = this.$t('password.dialogMessageOne');
        this.showDialog = true;
        this.reset({ key: 'Escape' });
        return;
      }

      if (this.newPassword == null || this.newPassword.length === 0) {
        this.dialogMessage = this.$t('password.dialogMessageTwo');
        this.showDialog = true;
        this.reset({ key: 'Escape' });
        return;
      }

      if (this.repeatPassword == null || this.repeatPassword.length === 0) {
        this.dialogMessage = this.$t('password.dialogMessageThree');
        this.showDialog = true;
        this.reset({ key: 'Escape' });
        return;
      }

      if (this.newPassword !== this.repeatPassword) {
        this.dialogMessage = this.$t('password.dialogMessageFour');
        this.showDialog = true;
        this.reset({ key: 'Escape' });
        return;
      }

        Auth.currentAuthenticatedUser().then(user => {
            Auth.changePassword(user, this.currentPassword, this.newPassword).then((result) => {
              this.disabledBtn = true
              this.dialogMessage = "Success!";
              this.showDialog = true;
              this.reset({ key: 'Escape' })
            }).catch((error) => {
              this.dialogMessage = error.message;
              this.showDialog = true;
              this.reset({ key: 'Escape' })
            });
          })
            .then(data => console.log(data))
            .catch(err => console.log(err));
    },

    reset(e) {
      if (e.key === 'Escape') {
        this.currentPassword = null;
        this.newPassword = null;
        this.repeatPassword = null;
        this.typeCurrentPassword = 'password';
        this.typeNewPassword = 'password';
        this.typeRepeatPassword = 'password';
        this.showCurrentPassword = false;
        this.showNewPassword = false;
        this.showRepeatPassword = false;
        this.code = null;
      }
    },
  },

  setup() {
    let account = ref(null)
    let accounts = ref([])
    let showM = ref(false)
    let hideBtn = ref(true)
    let confirmRequest = ref(false)
    let confirmVerification = ref(false)
    const internalInstance = getCurrentInstance()
    const emitter = internalInstance.appContext.config.globalProperties.emitter

    /*     let userInfo*/
    onMounted(() => {
      emitter.on('userUpdated', () => {
        load()
      })
      load()
    })

    onUnmounted(() => {
      emitter.off('userUpdated')
    })

    const load = () => {

      if (!store.state.user) {
        return
      }
    }

    return {
      account,
      accounts,
      showM,
      hideBtn,
      confirmRequest,
      confirmVerification
    }
  }
}
</script>

<style scoped>
</style>
